import React from 'react'
import { router, usePage, useForm } from '@inertiajs/react'
import {
  Box, Button, TextField, Select, MenuItem, FormControl, InputLabel,
  FormControlLabel, Switch, Paper, Typography, Grid,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, unit, buildings = [], action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'

  const { data, setData, post, put, processing, errors } = useForm({
    number: unit.number || '',
    category: unit.category || 'residential',
    building_id: unit.building_id || '',
    location: unit.location || '',
    floor: unit.floor || '',
    active: unit.active !== false,
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`/m/${tenant.slug}/properties/${property.id}/units/${unit.id}`)
    } else {
      post(`/m/${tenant.slug}/properties/${property.id}/units`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? `Einheit ${unit.number} bearbeiten` : 'Neue Einheit'}
        breadcrumbs={[
          { label: 'Einheiten', href: `/m/${tenant.slug}/properties/${property.id}/units` },
          { label: isEdit ? unit.number : 'Neue Einheit' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Nummer"
                required
                fullWidth
                size="small"
                value={data.number}
                onChange={(e) => setData('number', e.target.value)}
                error={!!allErrors.number}
                helperText={allErrors.number?.[0]}
                slotProps={{ htmlInput: { 'data-testid': 'number-input' } }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small" required error={!!allErrors.category}>
                <InputLabel>Kategorie</InputLabel>
                <Select
                  value={data.category}
                  label="Kategorie"
                  onChange={(e) => setData('category', e.target.value)}
                  data-testid="category-select"
                >
                  <MenuItem value="residential">Wohnung</MenuItem>
                  <MenuItem value="commercial">Gewerbe</MenuItem>
                  <MenuItem value="parking">Stellplatz</MenuItem>
                  <MenuItem value="other">Sonstiges</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {buildings.length > 0 && (
              <Grid size={{ xs: 12 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Gebäude</InputLabel>
                  <Select
                    value={data.building_id}
                    label="Gebäude"
                    onChange={(e) => setData('building_id', e.target.value)}
                  >
                    <MenuItem value="">Kein Gebäude</MenuItem>
                    {buildings.map((b) => (
                      <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Lage"
                fullWidth
                size="small"
                value={data.location}
                onChange={(e) => setData('location', e.target.value)}
                slotProps={{ htmlInput: { 'data-testid': 'location-input' } }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Etage"
                fullWidth
                size="small"
                value={data.floor}
                onChange={(e) => setData('floor', e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={data.active}
                    onChange={(e) => setData('active', e.target.checked)}
                  />
                }
                label="Aktiv"
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined"
              onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/units`)}>
              Abbrechen
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
